(function () {
  var METHODS = {
    screen: { name: 'Screen printing', link: 'screen', why: 'Bold, long-lasting color, and the best value once you are printing a dozen or more.' },
    dtf: { name: 'DTF transfers', link: 'dtf', why: 'Full color and fine detail that works well for smaller runs, photos, and busy artwork.' },
    emb: { name: 'Embroidery', link: 'emb', why: 'Stitched thread gives polos, jackets, and hats a premium, textured look that lasts.' },
    dtft: { name: 'DTF transfers', link: 'dtf', why: 'Full-color transfers made for you, ready to press onto shirts, hoodies, bags, and more with a heat press.' },
    pod: { name: 'Print on demand', link: 'pod', why: 'Each item is printed only when someone orders it, so you can sell your designs without buying or storing stock.' },
    sub: { name: 'Sublimation', link: 'sub', why: 'The ink becomes part of the item, so full-color designs on mugs, drinkware, and polyester gear will not peel or crack.' },
    large: { name: 'Large format prints', link: 'large', why: 'Big, bright banners, signs, and decals printed sharp at whatever size you need.' }
  };
  var ALSO = {
    screen: 'Have a second design with lots of colors? Ask us about DTF transfers.',
    dtf: 'Planning a big reorder of a simple design later? Screen printing can be the better value.',
    emb: 'Want the same logo on tees or hoodies? Screen printing works great for that.',
    large: 'Need the same design on apparel too? Ask about screen printing or DTF.',
    dtft: 'Do not have a heat press? Ask us about printing the design straight onto your shirts.',
    pod: 'Want to hold some stock too? Ask about DTF or screen printing for bulk runs.',
    sub: 'Sublimation works on polyester and coated items. Not sure yours qualifies? Call and ask.'
  };
  var COST = {
    screen: 'The price per piece drops as the quantity goes up, because the setup for each color is shared across the whole order.',
    dtf: 'There is no big setup to pay for, so small runs and detailed art stay affordable.',
    emb: 'Embroidery usually costs more per piece than printing, because of the stitching time. Simple logos keep it down.',
    dtft: 'Price depends on the transfer size and how many you order. Ordering more at once can lower the cost per transfer.',
    pod: 'You pay per item as it is ordered instead of paying for stock up front, so the cost per item is higher than a bulk run.',
    sub: 'Price depends on the item and the quantity. Larger orders of the same item can lower the cost per piece.',
    large: 'The price depends mostly on the size and the material, so tell us the dimensions and where it will hang.'
  };
  var BUDGET = {
    screen: { low: ' To keep costs down: order more at once, use fewer colors, and print in one spot.', mid: '', high: ' For the nicest result, ask about upgrading the shirts themselves.' },
    dtf: { low: ' To keep costs down: keep the print size modest and order together.', mid: '', high: ' For the nicest result, start with your highest-quality art and a premium shirt.' },
    emb: { low: ' To keep costs down: keep the logo small and simple, or ask about printing it instead.', mid: '', high: ' For the nicest result, choose a quality garment and a clean, simple logo.' },
    large: { low: ' To keep costs down: go a little smaller or choose a simpler material.', mid: '', high: ' For the nicest result, choose a sturdier material and send your sharpest art.' }
  };
  var PLACE = {
    in: ' Indoors, a lighter material usually works and costs less.',
    out: ' Outdoors, ask for a weather-ready material.'
  };
  var ART = {
    ready: 'Great. Upload it in our online designer, or call us if you want a second pair of eyes on it.',
    idea: 'An idea is a fine place to start. Try our online designer, or call us and we will talk it through.',
    help: 'No problem. Start in our online designer, or call us and we will talk it through.'
  };
  var TIMING = {
    norush: 'No rush? Send your art over whenever you are ready.',
    week: 'Working against a deadline this week? Give us a call so we can confirm timing.',
    asap: 'In a hurry? Call us first so we can tell you what is possible.'
  };

  function pick(a) {
    if (a.type === 'large' || a.type === 'dtft' || a.type === 'pod' || a.type === 'sub') return a.type;
    if (a.design === 'color') return 'dtf';
    if (a.type === 'emb') return 'emb';
    return (a.colors !== 'many' && a.qty === 'big') ? 'screen' : 'dtf';
  }
  function whyFor(a, key) {
    if (key === 'dtf' && a.design === 'color') {
      return a.type === 'emb'
        ? 'Embroidery is best for simple logos. For full-color art or photos on polos, jackets, or hats, DTF gives you every color and the fine detail.'
        : 'Full-color art and photos are exactly what DTF is for. Every color and every fine detail comes through.';
    }
    if (key === 'dtf' && a.type === 'tees') {
      if (a.colors === 'many') return 'Screen printing needs a separate screen for every color, so 6 or more colors gets expensive fast. DTF prints all of them in one pass.';
      return 'Screen printing has setup costs that only pay off on larger runs, usually a couple hundred pieces or more. For smaller orders, DTF is the better value.';
    }
    if (key === 'screen') return 'Your design is simple and your order is big enough that screen printing gives you the lowest cost per piece and the longest-lasting color.';
    return METHODS[key].why;
  }
  function costFor(a, key) {
    var t = COST[key] + ((BUDGET[key] && BUDGET[key][a.budget]) || '');
    if (key === 'large' && PLACE[a.place]) t += PLACE[a.place];
    return t;
  }
  function next(cur, a) {
    if (cur === 'type') {
      if (a.type === 'large') return 'place';
      if (a.type === 'dtft' || a.type === 'pod') return null;
      if (a.type === 'sub') return 'item';
      return 'design';
    }
    if (cur === 'item') return 'qty';
    if (cur === 'design') return (a.type === 'tees' && a.design === 'simple') ? 'colors' : 'budget';
    if (cur === 'place') return 'budget';
    if (cur === 'colors') return a.colors === 'many' ? 'budget' : 'qty';
    if (cur === 'qty') return 'budget';
    if (cur === 'budget') return a.type === 'pod' ? null : 'art';
    if (cur === 'art') return a.type === 'pod' ? 'budget' : 'when';
    return null;
  }
  function total(a) {
    if (a.type === 'pod' || a.type === 'dtft') return 1;
    if (a.type === 'sub') return 6;
    if (!a.type || a.type === 'large') return 5;
    if (a.type === 'emb' || a.design === 'color') return 5;
    return a.colors === 'many' ? 6 : 7;
  }

  document.querySelectorAll('[data-sa-quiz]').forEach(function (root) {
    var stepEls = {};
    root.querySelectorAll('.sa-quiz__step').forEach(function (s) { stepEls[s.getAttribute('data-step')] = s; });
    var bar = root.querySelector('.sa-quiz__bar i');
    var result = root.querySelector('.sa-quiz__result');
    var back = root.querySelector('.sa-quiz__back');
    var card = root.querySelector('.sa-quiz__card');
    var answers = {}, path = ['type'];

    function paint(done) {
      bar.style.width = Math.min(100, Math.round(done / total(answers) * 100)) + '%';
    }
    function show(name) {
      Object.keys(stepEls).forEach(function (k) { stepEls[k].hidden = k !== name; });
      result.hidden = true;
      card.classList.remove('is-result');
      back.hidden = path.length <= 1;
      paint(path.length - 1);
    }
    function finish() {
      var key = pick(answers), m = METHODS[key];
      Object.keys(stepEls).forEach(function (k) { stepEls[k].hidden = true; });
      result.hidden = false;
      card.classList.add('is-result');
      paint(total(answers));
      back.hidden = false;
      result.querySelector('.sa-quiz__method').textContent = m.name;
      result.querySelector('.sa-quiz__why').textContent = whyFor(answers, key);
      result.querySelector('.sa-fact__cost').textContent = costFor(answers, key);
      result.querySelector('.sa-fact__art').textContent = ART[answers.art] || '';
      result.querySelector('.sa-fact__when').textContent = TIMING[answers.when] || '';
      var direct = key === 'dtft' || key === 'pod';
      result.querySelector('.sa-quiz__facts').hidden = direct;
      result.querySelector('.sa-quiz__quote').hidden = direct;
      result.querySelector('.sa-quiz__also').textContent = ALSO[key];
      var shop = result.querySelector('.sa-quiz__shop');
      shop.setAttribute('href', root.getAttribute('data-link-' + m.link) || shop.getAttribute('href'));
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.sa-opt');
      if (opt) {
        var cur = path[path.length - 1];
        answers[opt.getAttribute('data-q')] = opt.getAttribute('data-v');
        if (cur === 'type') { answers = { type: answers.type }; }
        if (cur === 'design') { delete answers.colors; delete answers.qty; delete answers.budget; delete answers.art; delete answers.when; }
        opt.classList.add('is-picked');
        setTimeout(function () {
          opt.classList.remove('is-picked');
          var n = next(cur, answers);
          if (n) { path.push(n); show(n); } else { finish(); }
        }, 220);
        return;
      }
      if (e.target.closest('.sa-quiz__back')) {
        if (card.classList.contains('is-result')) { show(path[path.length - 1]); }
        else if (path.length > 1) { path.pop(); show(path[path.length - 1]); }
      }
    });
    show('type');
  });
})();
